import axiosInstance from '../RestClient';

const BASE_URI = '/credits';
class CreditService {
	async list(params = {populate: true})  {
		const uri = `${BASE_URI}`;
		const response = await axiosInstance.get(uri,{ params });
		return response;
	}

	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async search(query) {
		const uri = `${BASE_URI}/search?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}

	async editDate(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/editDate/${recordId}`, payload);
		return response;
	}

	async delete(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	async getDeletionPreview(recordId) {
		return axiosInstance.get(`${BASE_URI}/${recordId}/deletion-preview`);
	}

	async getDuesForcredit(creditId) {
		const uri = `${BASE_URI}/creditDues/${creditId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listForDashboard(params = {populate: true}) {
		const uri = `${BASE_URI}/dashboard`;
		const response = await axiosInstance.get(uri, { params });
		return response;
	}
}
export default new CreditService();
